import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";

import { addWorkoutPlan } from "../../services/workoutPlanService";

import "./WorkoutPlans.css";

export default function AddWorkoutPlan() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    planName: "",
    goal: "",
    level: "",

    monday: "",
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
    saturday: "",
    sunday: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    if (!formData.planName || !formData.goal || !formData.level) {
      alert("Please fill all required fields");
      return;
    }

    try {
      await addWorkoutPlan(formData);

      alert("Workout Plan Added Successfully");

      navigate("/workout-plans");
    } catch (error) {
      console.error(error);
      alert("Failed to Save Workout Plan");
    }
  };

  return (
    <DashboardLayout>
      <div className="workout-container">
        <div className="workout-header">
          <div>
            <h1>Add Workout Plan</h1>
            <p>Create a weekly workout plan for Premium members.</p>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-grid">
            <div className="form-group">
              <label>Plan Name</label>

              <input
                type="text"
                name="planName"
                placeholder="Beginner Fat Loss"
                value={formData.planName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Goal</label>

              <select name="goal" value={formData.goal} onChange={handleChange}>
                <option value="">Select Goal</option>

                <option>Fat Loss</option>

                <option>Weight Gain</option>

                <option>Muscle Gain</option>

                <option>Strength</option>

                <option>General Fitness</option>
              </select>
            </div>

            <div className="form-group">
              <label>Level</label>

              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
              >
                <option value="">Select Level</option>

                <option>Beginner</option>

                <option>Intermediate</option>

                <option>Advanced</option>
              </select>
            </div>

            <div className="form-group">
              <label>Monday</label>

              <input
                type="text"
                name="monday"
                value={formData.monday}
                onChange={handleChange}
                placeholder="Chest + Triceps"
              />
            </div>

            <div className="form-group">
              <label>Tuesday</label>

              <input
                type="text"
                name="tuesday"
                value={formData.tuesday}
                onChange={handleChange}
                placeholder="Back + Biceps"
              />
            </div>

            <div className="form-group">
              <label>Wednesday</label>

              <input
                type="text"
                name="wednesday"
                value={formData.wednesday}
                onChange={handleChange}
                placeholder="Legs"
              />
            </div>

            <div className="form-group">
              <label>Thursday</label>

              <input
                type="text"
                name="thursday"
                value={formData.thursday}
                onChange={handleChange}
                placeholder="Shoulders"
              />
            </div>

            <div className="form-group">
              <label>Friday</label>

              <input
                type="text"
                name="friday"
                value={formData.friday}
                onChange={handleChange}
                placeholder="Arms"
              />
            </div>

            <div className="form-group">
              <label>Saturday</label>

              <input
                type="text"
                name="saturday"
                value={formData.saturday}
                onChange={handleChange}
                placeholder="Cardio"
              />
            </div>

            <div className="form-group">
              <label>Sunday</label>

              <input
                type="text"
                name="sunday"
                value={formData.sunday}
                onChange={handleChange}
                placeholder="Rest"
              />
            </div>
          </div>

          <button className="add-plan-btn" onClick={handleSave}>
            Save Workout Plan
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
